import classNames from 'classnames';
import React, { Component } from 'react';
import get from 'lodash.get';

import loadScript from 'lib/loadScript';
import embeddedWidgetProps from 'lib/CustomPropTypes/embeddedWidget';
import styles from '../styles.module.scss';
import FacebookEmbed from './FacebookEmbed';

export default class IframelyEmbed extends Component {
  static propTypes = embeddedWidgetProps.isRequired;

  componentDidMount() {
    // Iframely's embed.js script should be loaded once for all embeds
    loadScript('https://iframe.nbcnews.com/embed.js');
  }

  render() {
    const {
      presentation,
      widget,
    } = this.props;

    const siteName = get(widget, 'properties.iframely-embed-site', '').toLowerCase();

    /*
      Facebook embeds do not handle responsive behavior correctly.
      To avoid cutting off the embed or causing horizontal overflow,
      we use the existing Ramen Facebook embed with responsive sizing set.
     */
    if (siteName === 'facebook') {
      const reshapedEmbedObject = {
        ...widget,
        properties: {
          'facebookplus-post-url': widget.fallbackUrl,
        },
      };

      return (
        <FacebookEmbed
          presentation={presentation}
          widget={reshapedEmbedObject}
          facebookPostType="post"
        />
      );
    }

    // Iframely uses an iframe to wrap all social embeds.
    // The iframe is injected into a container for rendering.
    const iframelyEmbed = widget.baseline;

    return (
      <div
        className={classNames(styles.usePresentation, styles[`iframely-${siteName}`])}
        data-test="iframely-wrapper"
        /* eslint-disable-next-line react/no-danger */
        dangerouslySetInnerHTML={{ __html: iframelyEmbed }}
      />
    );
  }
}
